import { render, staticRenderFns } from "./Zhihu.vue?vue&type=template&id=39d7a8c4&scoped=true"
import script from "./Zhihu.vue?vue&type=script&lang=js"
export * from "./Zhihu.vue?vue&type=script&lang=js"
import style0 from "./Zhihu.vue?vue&type=style&index=0&id=39d7a8c4&prod&scoped=true&lang=css"
import style1 from "./Zhihu.vue?vue&type=style&index=1&id=39d7a8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7a8c4",
  null
  
)

export default component.exports